// ════════════════════════════════════════════════════════
//  features/veiculos/services/veiculoService.ts
// ════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type { VeiculoListagemDto, VeiculoDto, VeiculoComboDto, SalvarVeiculoRequest } from '../types';
import type { PaginadoResponse } from '@/features/financeiro/types';

export const veiculoService = {
  listar: (busca?: string, pagina = 1, tamanhoPagina = 50) =>
    apiClient
      .get<PaginadoResponse<VeiculoListagemDto>>('/api/cadastros/veiculos', {
        params: { busca, pagina, tamanhoPagina },
      })
      .then(r => r.data),

  obterPorId: (id: number) =>
    apiClient.get<VeiculoDto>(`/api/cadastros/veiculos/${id}`).then(r => r.data),

  combo: () =>
    apiClient.get<VeiculoComboDto[]>('/api/veiculos').then(r => r.data),

  criar: (req: SalvarVeiculoRequest) =>
    apiClient.post<VeiculoDto>('/api/cadastros/veiculos', req).then(r => r.data),

  atualizar: (id: number, req: SalvarVeiculoRequest) =>
    apiClient.put(`/api/cadastros/veiculos/${id}`, req),

  excluir: (id: number) =>
    apiClient.delete(`/api/cadastros/veiculos/${id}`),
};
